module.exports = __webpack_public_path__ + "static/media/Bolivia.97ff0ac5.png";